import { ArkoseViewModel } from '@external/captcha/arkose/types';
import { GeetestViewModel } from '@external/captcha/geetest/types';
import { RecaptchaViewModel } from '@external/captcha/recaptcha/types';
import { CaptchaViewModel } from '@external/captcha/types';
import { InfoResponse } from '@ul/api';

export const toCaptchaViewModel = (response: InfoResponse): CaptchaViewModel | undefined => {
    const { captchaInfo } = response;
    if (!captchaInfo) {
        return;
    }

    switch (captchaInfo.captchaType) {
        case 'recaptcha':
        case 'invisible':
            const recaptchaVm: RecaptchaViewModel = {
                apiKey: captchaInfo.apiKey!,
            };
            return {
                type: captchaInfo.captchaType,
                ...recaptchaVm,
            };
        case 'arkose':
            const arkoseVm: ArkoseViewModel = {
                apiKey: captchaInfo.apiKey!,
            };
            return {
                type: captchaInfo.captchaType,
                ...arkoseVm,
            };
        case 'geetest':
            const geetestVm: GeetestViewModel = {
                success: response.captchaInfo?.success!,
                challenge: response.captchaInfo?.challenge!,
                gt: response.captchaInfo?.gt!,
                new_captcha: response.captchaInfo?.new_captcha!,
            };
            return {
                type: captchaInfo.captchaType,
                ...geetestVm,
            };
        default:
            return;
    }
};
